function loadPanorama(element) {
  if (!shouldInitPanorama(element)) {
    document.addEventListener('scroll', onScrollHandler);
  }

  function onScrollHandler() {
    if (shouldInitPanorama(element)) {
      document.removeEventListener('scroll', onScrollHandler);
    }
  }
}

function shouldInitPanorama(element) {
  const rect = element.getBoundingClientRect();
  const imageUrl = element.dataset.image;
  let showCoverTimeout = null;
  let mouseDownPos = {x: null, y: null};
  element.style.setProperty('--height-mobile', element.dataset.heightmobile);
  element.style.setProperty('--height-pc', element.dataset.heightpc);

  const cover = element.querySelector('.panorama-cover');
  cover.addEventListener('click', handleCoverClick);
  element.addEventListener('mousedown', handlePanoramaMouseDown);
  element.addEventListener('mouseup', handlePanoramaMouseUp);
  element.addEventListener('dblclick', handlePanoramaDblClick);


  if ((rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) + 100)) {
    pannellum.viewer(element, {
      "type": "equirectangular",
      "panorama": imageUrl,
      "autoLoad": true,
    });

    return true;
  }

  return false;

  function handleCoverClick(event) {
    if (event.target === cover) {
      cover.style.display = 'none';
    }
  }

  function handlePanoramaMouseDown(event) {
    if (event.target !== cover) {
      mouseDownPos.x = event.x;
      mouseDownPos.y = event.y;
    }
  }

  function handlePanoramaDblClick(event) {
    if (event.target !== cover) {
      clearTimeout(showCoverTimeout);
    }
  }

  function handlePanoramaMouseUp(event) {
    const isDrag = Math.abs(mouseDownPos.x - event.x) > 20 || Math.abs(mouseDownPos.y - event.y) > 20;

    if (event.target !== cover && !isDrag && event.detail === 1) {
      showCoverTimeout = setTimeout(() => {
        cover.style.display = 'flex';
      }, 250);
    }
  }
}

export function initPanoramas() {
  document.querySelectorAll('.panorama').forEach((c, idx) => loadPanorama(c, idx));
}
